import CryptoJS from "crypto-js";

export function encryptData(data: string, passphrase: string) {
  // make 128 bit key from user and account ids.
  const k = CryptoJS.MD5(passphrase);
  // TODO: make sure to use CTR mode, not ECB mode
  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), k, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.ZeroPadding,
  });
  return encrypted.toString(CryptoJS.format.Hex);
}

export function decryptData(data: string, passphrase: string) {
  try {
    const k = CryptoJS.MD5(passphrase);
    const ciphertext = CryptoJS.format.Hex.parse(data);
    const decrypted = CryptoJS.AES.decrypt(ciphertext, k, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.ZeroPadding,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch {
    return "";
  }
}
